exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".relief[data-v-7a48d0fa]{width:100%;height:8px;position:fixed;bottom:8%;left:0;opacity:.5;z-index:20}.box[data-v-7a48d0fa]{height:8px;width:100%;line-height:8px;position:relative;white-space:pre-wrap}p[data-v-7a48d0fa]{line-height:8px;font-size:4px;position:absolute;padding-left:20px;padding-right:20px;top:0;left:0;white-space:nowrap;color:#aaa;font-family:\\\\5FAE\\8F6F\\96C5\\9ED1}@keyframes run-data-v-7a48d0fa{0%{left:0}to{left:-100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a48d0fa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Relief.vue
// module id = 197
// module chunks = 11